// extracted by mini-css-extract-plugin
module.exports = {"locationTag":"LocationTag_locationTag__TCOUA","locationIcon":"LocationTag_locationIcon__zj5M8","countryName":"LocationTag_countryName__aPcnr"};